// Course definitions shared by the 3D world and the HTML overlay.
// The order here is the arrow-navigation order. Island `i` lives below the
// previous one at y = -i * SPACING, so the camera travels vertically.
//
// `accent` is a literal hex because it is handed to three.js as well as to CSS.
// `accentInk` is its light-theme twin: the gems are built to glow against the
// night palette and only reach 1.5–2.6:1 as text on white, so anything that
// *reads* as text or a state indicator uses the ink instead.
import { ACCENT_INK_LIGHT, T } from '../../utils/fonts';

/** Distance between two course islands, in world units. */
// Close enough that adjacent islands overlap the camera's vertical frustum
// during a flight. A larger gap produced a brief empty scene when visitors
// advanced through two courses quickly.
export const SPACING = 15;

export const COURSES = [
  {
    id: 'gamedev',
    hud: 'GAME DEV',
    title: 'קורס פיתוח משחקים',
    description: 'למדו לפתח משחקים עם מנוע המשחק של גודו.',
    price: '490',
    ageRange: '14-18 / 10-13',
    schedule: 'פעם בשבוע – שעתיים אקדמיות ושעת תגבור',
    totalHours: '64 שעות',
    syllabusLink: '/gamedev-syllabus.pdf',
    accent: T.godotBlue,
    accentInk: ACCENT_INK_LIGHT.godotBlue,
    scene: { kind: 'godot' },
  },
  {
    id: 'minecraft',
    hud: 'MINECRAFT',
    title: 'קורס תכנות במיינקראפט',
    description: 'לומדים לתכנת דרך מיינקראפט – מבלוקים ועד קוד Python אמיתי.',
    price: '350',
    ageRange: '14-18 / 10-13',
    schedule: 'פעם בשבוע – שעה אקדמית + שעת תגבור',
    totalHours: '32 שעות',
    syllabusLink: '/minecraft-syllabus.pdf',
    accent: T.minecraft,
    accentInk: ACCENT_INK_LIGHT.minecraft,
    scene: { kind: 'minecraft' },
  },
  {
    id: 'python',
    hud: 'PYTHON',
    title: 'קורס תכנות (פייתון)',
    description: 'למדו את יסודות התכנות בשפת פייתון בצורה חווייתית.',
    price: '350',
    ageRange: '14-18 / 10-13',
    schedule: 'פעם בשבוע – שעה אקדמית + שעת תגבור',
    totalHours: '32 שעות',
    syllabusLink: '/python-syllabus.pdf',
    accent: T.python,
    accentInk: ACCENT_INK_LIGHT.python,
    scene: { kind: 'python' },
  },
  {
    id: 'web3d',
    hud: 'WEB 3D',
    title: 'קורס פיתוח אתרים תלת-ממדי',
    description: 'צרו אתרים אינטראקטיביים עם גרפיקה תלת-ממדית.',
    price: '490',
    ageRange: '14-18 / 10-13',
    schedule: 'פעם בשבוע – שעתיים אקדמיות ושעת תגבור',
    totalHours: '64 שעות',
    syllabusLink: '/web3d-syllabus.pdf',
    accent: T.web3d,
    accentInk: ACCENT_INK_LIGHT.web3d,
    scene: { kind: 'web3d' },
  },
];
